import { Button } from '@zillow/constellation-10';

import { css } from '@/styled-system/css';
import { shimmerStyles } from '../styles/ShimmerStyles';

import type { ButtonPropsInterface } from '@zillow/constellation-10';
export const LoadingButton = ({
  isLoading,
  loadingWidth,
  children,
  css: cssProp,
  style: styleProp,
  disabled,
  icon,
  ...rest
}: {
  isLoading: boolean;
  loadingWidth?: string;
} & ButtonPropsInterface) => (
  <Button
    data-loading={isLoading || null}
    css={css.raw(cssProp, shimmerStyles, { _loading: { boxShadow: 'none' } })}
    style={isLoading ? { width: loadingWidth ? loadingWidth : '100%', ...styleProp } : { ...styleProp }}
    icon={isLoading ? null : icon}
    disabled={isLoading ? true : disabled}
    {...rest}
  >
    {isLoading ? <Button.Label>&nbsp;</Button.Label> : children}
  </Button>
);
